import { render, staticRenderFns } from "./CasesByDepartment.vue?vue&type=template&id=494b669a&"
import script from "./CasesByDepartment.vue?vue&type=script&lang=js&"
export * from "./CasesByDepartment.vue?vue&type=script&lang=js&"
import style0 from "./CasesByDepartment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports